import { SC_Input } from '../input/SC_Input';
import { Sol50 } from '../mountsys/Sol50';

export class GetArea {
    public x: number;
    public y: number;
    /**
     * width of the group<br>
     * Attention: this field is set and used in the panel array editor only
     */
    public width: number = 0;
    public height: number = 0;
    public nModWidth: number;
    public nModHeight: number;
    public portrait: boolean;
    public mixed: boolean = false;
    
    constructor(obj: any[]) {
        let panelWidth = (SC_Input.nModWidth / 10);
        let panelHeight = (SC_Input.nModHeight / 10);
        this.portrait = obj[0].portrait;
        let w: number, h: number;
        if (this.portrait) {
            w = panelWidth
            h = panelHeight;
        } else {
            w = panelHeight;
            h = panelWidth;
        }
        this.x = obj[0].x;
        this.y = obj[0].y;
        obj.forEach((item, i) => {
            if (this.width == 0) this.width = w * item.panelCount + Sol50.nHorizontalAbstand * (item.panelCount - 1);
            this.height += h;
            if (i > 0) this.height += Sol50.nVertikalAbstand;
            if (this.y > item.y) this.y = item.y;
            if(item.mixed) this.mixed = true;
        })
        this.nModWidth = w;
        this.nModHeight = h;
    }
}